import { render, staticRenderFns } from "./FeedbackWidget.vue?vue&type=template&id=6282d848&scoped=true&"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js&"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackWidget.vue?vue&type=style&index=0&id=6282d848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282d848",
  null
  
)

export default component.exports